import { createContext } from 'react';

const FeatureFlagContext = createContext([]);

export default FeatureFlagContext;
